import { BrandCaptionLowerThirdEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandCaptionLowerThirdUnUseVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandCaptionLowerThirdUnUseVO.validationSchema(),
    BrandCaptionLowerThirdEntity
  );

  constructor(readonly value: RoomBrandCaptionLowerThirdUnUse) {
    JsonSchemaValidator.assert(
      RoomBrandCaptionLowerThirdUnUseVO.validation,
      value
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandCaptionLowerThird"],
      properties: {
        roomId,
        brandCaptionLowerThird: {
          instanceof: BrandCaptionLowerThirdEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandCaptionLowerThirdUnUse {
  roomId: RoomId;
  brandCaptionLowerThird: BrandCaptionLowerThirdEntity;
}
